import React, {useEffect, useState, Fragment} from 'react'
import { TextField } from '@material-ui/core'
import axios, {AxiosResponse} from 'axios'
import { Autocomplete } from '@mui/material';
import {useLang} from '../../../_metronic/i18n/Metronici18n'
import {SortableContainer, SortableElement} from 'react-sortable-hoc';


const API_URL = process.env.REACT_APP_API_URL

const headers = {
    'Content-Type': 'application/json',
    'Accept' : 'application/json'
}

const AutocompleteForm = (props: any) => {
 	 
 	const lang = useLang()
 	
 	   
    const [options, setOptions] = useState([])
    const [updated, setUpdated] = useState(0)
    const [values, setValues] = useState<any[]|null>(null)
    
    var alreadyLoadedIds: any = []
    var alreadyOptions: any = []
    
    
    useEffect(() => {
      //  console.log("useEffect")
    }, [])


    const setValue = (values_selected: any) => {
	    
	    //TEXT FORMAT FOR VALIDATION RULES (ARRAY => STRING)
	    var newValues: any = []
	    values_selected.forEach((value: any)=>{
		    newValues.push(value.value)
		})
		
		window.FormSettings[props.form_name][props.field.name]['value'] = values_selected
		props.formikProps.values[props.field.name] = newValues.join(", ")
		
    }
    
    
    const pushValue = (values_selected: any) => {
	    
	    if(props.element.multiple){
	    
		    //TEXT FORMAT FOR VALIDATION RULES (ARRAY => STRING)
		    var newValues: any = props.formikProps.values[props.field.name].split(", ")
		    
		    values_selected.forEach((value: any)=>{
			    if(newValues.indexOf(value.value) == -1){
				    newValues.push(value.value)
				    window.FormSettings[props.form_name][props.field.name]['value'].push(value)
			    }
			})
			
			props.formikProps.values[props.field.name] = newValues.join(", ")
		
		}else{
			
			if(values_selected){
				window.FormSettings[props.form_name][props.field.name]['value'] = [values_selected]
				
				props.formikProps.values[props.field.name] = values_selected.value
			}
			
		}
		
    }
    
    
    
    const deleteValue = (value_delete: any) => {
	    
	    var values_selected = window.FormSettings[props.form_name][props.field.name]['value']
	    
	    //TEXT FORMAT FOR VALIDATION RULES (ARRAY => STRING)
	    var newValues: any = []
	    var newValuesObj: any = []
	    
	    values_selected.forEach((value: any)=>{
		    if(value_delete.value != value.value){
			    newValues.push(value.value)
			    newValuesObj.push(value)
		    }
	    
		})
		
		props.formikProps.values[props.field.name] = newValues.join(", ")
		window.FormSettings[props.form_name][props.field.name]['value'] = newValuesObj
		
		
		setValue(newValuesObj)
		setValues(newValuesObj)
		
    }
    
    
    const renderHTML = (rawHTML: string) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
    
    const reloadOptions = (event: any) => {
	    
	    
	    if(event){
			//LOAD ENTITY AUTCOMPLETE BY CONTENT TYPE
			const bundle  = Object.values(window.FormSettings[props.form_name][props.field.name]['bundle']).join("+")
			const target_type  = window.FormSettings[props.form_name][props.field.name]['target_type']
			
			const build_url = API_URL  + "/" + lang + '/autocomplete/' + target_type + "/" + bundle + "?_format=hal+json&filter=" + event.target.value
		
		    axios.get(build_url, {headers})
	            .then((response: AxiosResponse) => {
		            
		            //ON FUSIONNE AVEC LES OPTIONS DEJA CHARGE (POUR NE PAS PERDRE LES VALEURS INITIALES)
		            response.data.forEach((value: any)=>{
			            
			            value.label = value.label.replace("&amp;", "&")
			            
			            if(typeof value.label_html == "undefined"){
				            value.label_html = value.label
			            }
			            //value.label = renderHTML(value.label)
			            
			            if(alreadyLoadedIds.indexOf(value.value) === -1){
						    alreadyLoadedIds.push(value.value)
							alreadyOptions.push(Object.assign({}, value))
						}
					})
		            
	                //SET STATE OPTIONS
					setOptions(alreadyOptions)
					
	            });
        }else{
	        setOptions(alreadyOptions)
        }
		
    }
  
 
    //EXTRACT ID
    const formDrupalValues = () => {
	    
	    if(window.FormSettings[props.form_name][props.field.name]['value']){
		    
		    //IDS OPTIONS
		    //var ids: any = []
		    //console.log("window.FormSettings[props.form_name][props.field.name]['value']", window.FormSettings[props.form_name][props.field.name]['value'])
		    window.FormSettings[props.form_name][props.field.name]['value'].forEach((value: any)=>{
			    alreadyLoadedIds.push(value.value)
			    alreadyOptions.push(Object.assign({}, value))
			})
			
			setValue(window.FormSettings[props.form_name][props.field.name]['value'])
			
		    return window.FormSettings[props.form_name][props.field.name]['value']
	    }
	    
    }
    
    const SortableItem = SortableElement((value: any) => {
	    return (
		    <li value={value.value} className={value.type}>
		    	<span dangerouslySetInnerHTML={{__html: typeof value.label_html != "undefined" ? value.label_html : value.label}}></span>
		    	<a className="btn-close" 
	          	 onClick={(e)=>{
                    deleteValue(value)
                    e.stopPropagation()
                    return false 
                 }}>
	          	</a>
		    </li>
		)
	});
    
    
    const SortableList = SortableContainer((items:any) => {
	  return (
	    <ul className="dragndrop">
	      {items.items.map((value: any, index: any) => (
		      
	        <SortableItem key={'item-' + value.value} index={index} label={value.label} value={value.value} label_html={value.label_html} type={value.type} />
	      ))}
	    </ul>
	  );
	});
	
	const sortChange = (datas: any, event: any) => {
		
		if(datas.oldIndex != datas.newIndex){
			
			//SET VALUES
			var orderValues = window.FormSettings[props.form_name][props.field.name]['value']
			var itemToMove = Object.assign({}, orderValues[datas.oldIndex])
			
			orderValues[datas.oldIndex] = null
			 
			var newValues : any = []
			
			orderValues.map((item: any, i: any) => {
				if(item !== null){
					if(datas.newIndex == i){
						//PUSH MOVE ELEMENT
						newValues.push(itemToMove)
					} 
					newValues.push(item)
					
				}
				
			})
			
			//window.FormSettings[props.form_name][props.field.name]['value'] = newValues
			
			//console.log("sortChangenewValues", newValues, options) 
			
			setValue(newValues)
			
			setValues(newValues)
		
		}
	    
    }
	
    const inputValue = formDrupalValues()
    
    
    
    //console.log("inputValue", inputValue, options)
    
   // const myUncontrolledAutocomplete=React.createRef();
 
    return (
	    <div>
		    <div>
				<Autocomplete
				  //ref={myUncontrolledAutocomplete}
				  noOptionsText={' '}
				  disablePortal
				  id={props.element.id ? "auto-" + props.element.id.toString() : ""}
				  options={options}
				  sx={{  }}
				  multiple={ props.element.multiple }
				  className='form-control form-control-solid form-control-lg '
				 // value={inputValue}
				  renderInput={(params) => <TextField {...params} label="" 
				  onKeyDown={(newValue) => {
				      reloadOptions(newValue);
				  }}
				  onPaste={(newValue) => {
				      reloadOptions(newValue);
				  }} />}
				  onChange={(event, newValue) => {
				      //setValue(newValue)
				      pushValue(newValue)
				    //  console.log(newValue)
				    if(props.element.multiple){
				      setValues(newValue)
				    }else{
					    setValues([newValue])
				    }
				  }}
				/>
			</div>
			
			
	
		    {typeof inputValue != "undefined" ? (
		        <>
		        	<SortableList items={inputValue} onSortEnd={sortChange} distance={1}/>
		        </>
		    ):(
		        <></>
		    )}
		    
		</div>
    )
 
	
	
	        
}


export default AutocompleteForm
